const PRODUCT_QUANTITY = 'productsUnitMultiplier'

const updateProducts = (products: { [x: string]: number }): void => {
  localStorage.setItem(PRODUCT_QUANTITY, JSON.stringify(products))
}

export default {
  updateProducts
}